import { useRef } from 'preact/hooks'
import { SafeAreaRefType } from 'components/ui/SafeArea'

export default function useRefs() {
  const contentRef = useRef<HTMLDivElement>(null)
  const brandingRef = useRef<HTMLDivElement>(null)
  const scrollAreaRef = useRef<HTMLDivElement>(null)
  const safeAreaRef = useRef<SafeAreaRefType>(null)
  const submitLoadingRef = useRef(false)

  return {
    contentRef,
    brandingRef,
    scrollAreaRef,
    safeAreaRef,
    submitLoadingRef,
  }
}
